import { AloDbMission } from '@/models/alodb/AloDbMission'
import { FilterBase } from '@/models/filter/FilterBase'
import { FilterAdminMission } from '@/models/filter/FilterAdminMission'
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping'

export interface IAdminMissionState {
  status: string
  adminMissions: Array<AloDbMission>
  modifiedAdmAdminMission: AloDbMission
  originalAdmAdminMission: AloDbMission
  modifiedAdmAdminMissionRolesMapping: Array<AloDbRoleMapping>  
  adminMissionLoading: boolean
  adminMissionRoleMappingLoading: boolean
  adminFilter: FilterAdminMission
}

const state: IAdminMissionState = {
  status: '',
  adminMissions: [],
  modifiedAdmAdminMission: new AloDbMission(),
  originalAdmAdminMission: new AloDbMission(),
  modifiedAdmAdminMissionRolesMapping:[],
  adminMissionLoading: false,
  adminMissionRoleMappingLoading: false,
  adminFilter: new FilterAdminMission()
}

export default state
